// NsModeBar — the NetSuite-mode menu bar, rendered inside Run so the NS chrome
// survives cross-app jumps (Enter Sales Order, receiving, pick tickets, …).
// Count's bar is the original; this renders the SAME menu data (generated copy
// in ./nsMenuData.js) with Run-appropriate link handling:
//   to:   Count route            -> absolute link to ns.daydreamerconcepts.com
//   href: Run absolute URL       -> relative (stay in-app), ns flag preserved
//   href: other app absolute URL -> unchanged
// Mounted by App.js only while NS mode is active (?ns=1 sets it; the pill's X
// clears it). Deliberately mirrors the Count bar's look: NS green, white text.
import React, { useState, useRef, useEffect } from 'react';
import { MENUS, RUN } from './nsMenuData';
import './NsModeBar.css';

const NS_BASE = 'https://ns.daydreamerconcepts.com';
const FLAG = 'nsModeOn';

export function nsModeActive() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('ns') === '1') localStorage.setItem(FLAG, '1');
    if (params.get('ns') === '0') localStorage.removeItem(FLAG);
    return localStorage.getItem(FLAG) === '1';
  } catch {
    return false;
  }
}

function leafHref(leaf) {
  if (leaf.to) return `${NS_BASE}${leaf.to}`;
  if (leaf.href && leaf.href.startsWith(RUN)) {
    const rel = leaf.href.slice(RUN.length);
    return rel.includes('?ns=') ? rel : `${rel}${rel.includes('?') ? '&' : '?'}ns=1`;
  }
  return leaf.href;
}

function Leaf({ leaf }) {
  return (
    <a className="nsbar-leaf" href={leafHref(leaf)}>
      {leaf.label}
      {leaf.to ? <span className="nsbar-app">Count</span> : leaf.app && !leaf.href.startsWith(RUN) ? <span className="nsbar-app">{leaf.app}</span> : null}
    </a>
  );
}

export default function NsModeBar() {
  const [open, setOpen] = useState(null); // top-level menu label
  const barRef = useRef(null);

  useEffect(() => {
    const close = (e) => { if (barRef.current && !barRef.current.contains(e.target)) setOpen(null); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const exit = () => {
    try { localStorage.removeItem(FLAG); } catch { /* noop */ }
    window.location.href = NS_BASE;
  };

  return (
    <div className="nsbar" ref={barRef}>
      <a className="nsbar-home" href={NS_BASE} title="NetSuite mode home">⌂</a>
      {MENUS.map((menu) => (
        <div key={menu.label} className="nsbar-menu">
          <button
            className={`nsbar-top${open === menu.label ? ' open' : ''}`}
            onClick={() => setOpen(open === menu.label ? null : menu.label)}
          >
            {menu.label}
          </button>
          {open === menu.label && (
            <div className="nsbar-drop">
              {(menu.children || []).map((group) =>
                group.children ? (
                  <div key={group.label} className="nsbar-group">
                    <div className="nsbar-group-label">{group.label}</div>
                    {group.children.map((leaf) => <Leaf key={leaf.label} leaf={leaf} />)}
                  </div>
                ) : (
                  <Leaf key={group.label} leaf={group} />
                )
              )}
            </div>
          )}
        </div>
      ))}
      <div className="nsbar-spacer" />
      <button className="nsbar-pill" onClick={exit} title="Exit NetSuite mode (returns to ns home)">
        NS mode on — in Run ✕
      </button>
    </div>
  );
}
